import { Component, OnInit } from '@angular/core';
import { isMPay, isSkycash, salesChannel } from '../../../../core/utils/utils';
import {SalesChannel} from '../../../../core/consts/sales-channel.enum';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {TranslationDefinition} from '../../../models/translation-definition';
import {ResourceService} from '../../../services/resource.service';
import {ResourceKey} from '../../../../core/consts/resource-key.enum';

@Component({
  selector: 'app-information-clause-section',
  templateUrl: './information-clause-section.component.html',
  styleUrls: ['./information-clause-section.component.scss']
})
export class InformationClauseSectionComponent implements OnInit {

  paragraphs: TranslationDefinition[];
  expanded = false;

  get expandSectionMode(): boolean {
    return isMPay() && this.urlParamsService.isMobileOrigin;
  }

  get translationsContainer(): string {
    switch (salesChannel()) {
      case SalesChannel.MPAY:
        return 'MPAY_INFORMATION_CLAUSE_SECTION';
      case SalesChannel.OLX:
        return 'OLX_INFORMATION_CLAUSE_SECTION';
      case SalesChannel.SKYCASH:
        return 'SKYCASH_INFORMATION_CLAUSE_SECTION';
    }
  }

  constructor(private urlParamsService: UrlParamsService,
              private resourceService: ResourceService) { }

  ngOnInit() {
    this.paragraphs = this.getParagraphs();
  }

  expandContent(): void {
    this.expanded = true;
  }

  private getParagraphs(): TranslationDefinition[] {
    switch (salesChannel()) {
      case SalesChannel.OLX:
        return [
          {
            path: 'OLX_INFORMATION_CLAUSE_SECTION.paragraph1'
          },
          {
            path: 'OLX_INFORMATION_CLAUSE_SECTION.paragraph2',
            params: {
              regulationsUri: this.resourceService.buildResourceUrlFromKey(ResourceKey.KP_REGULATIONS)
            }
          }
        ];
      case SalesChannel.MPAY: {
        return [
          {
            path: 'MPAY_INFORMATION_CLAUSE_SECTION.paragraph1'
          },
          {
            path: 'MPAY_INFORMATION_CLAUSE_SECTION.paragraph2',
            params: {
              regulationsUri: this.resourceService.buildResourceUrlFromKey(ResourceKey.KP_REGULATIONS)
            }
          }
        ];
      }
      case SalesChannel.SKYCASH: {
        return [
          {
            path: 'SKYCASH_INFORMATION_CLAUSE_SECTION.paragraph1'
          },
          {
            path: 'SKYCASH_INFORMATION_CLAUSE_SECTION.paragraph2',
            params: {
              regulationsUri: this.resourceService.buildResourceUrlFromKey(ResourceKey.KP_REGULATIONS)
            }
          }
        ];
      }
    }
  }

}
